module.exports = __webpack_public_path__ + "img/add-circle.23319849.svg";